// extracted by mini-css-extract-plugin
export var wordContainer = "_me-0";